import React from 'react'
// import ReactDOM from 'react-dom';
import PropTypes from 'prop-types'

const stringForStatKey = function(key) {
	switch(key) {
	case 'oneYearSpend':
		return '1 Year Ad Spend'
	case 'totalCampaignCount':
		return 'Total # of Campaigns'
	case 'totalAdsetCount':
		return 'Number of Ad Sets'
	case 'spend30d':
		return '30 Day Spend'
	case 'averageDailySpend':
		return 'Daily Spend Velocity'
	case 'liveCampaignCount':
		return 'Number of Live Campaigns'
	case 'oneMonthReach':
		return '30 Day Reach'
	default:
		return key
	}
}

const valueForStat = function(key, value) {
	switch(key) {
	case 'oneYearSpend':
	case 'spend30d':
	case 'averageDailySpend':
		return '$' + (value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
	default:
		return value
	}
}

export default function SummaryItem(props) {
	let {idx, stat} = props
	return (
		<div className="data-group" key={idx}>
			<p className="data-group__title">{stringForStatKey(stat.key)}</p>
			<p className="data-group__value">{valueForStat(stat.key, stat.value)}</p>
		</div>
	)
}

SummaryItem.propTypes = {
	idx: PropTypes.number,
	stat: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/SummaryItem.js